import { render } from "./StoreReviewLaunch.vue?vue&type=template&id=31198bee&scoped=true"
import script from "./StoreReviewLaunch.vue?vue&type=script&lang=js"
export * from "./StoreReviewLaunch.vue?vue&type=script&lang=js"

import "./StoreReviewLaunch.vue?vue&type=style&index=0&id=31198bee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31198bee"]])

export default __exports__